import {Injectable, OnDestroy} from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class Destroyer implements OnDestroy {

  protected unsubscribeAll: Subject<void> = new Subject();

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
